<template>
    <div class="post-sale-main">
        <!-- 导航栏 -->
        <van-sticky
            type="primary"
            v-if="isWechat"
        >
            <van-nav-bar
                title="发起纠纷"
                left-text="返回"
                left-arrow
                @click-left="onGoBack"
            />
        </van-sticky>
        <!-- sku信息 -->
        <div class="post-sale__goods-sku-name">{{skuName}}</div>
        <!-- 纠纷信息收集 -->
        <div class="post-sale__post-sale-wrapper">
            <div class="post-sale__post-sale-title">纠纷原因</div>
            <div class="post-sale__post-sale-form-wrapper">
                <van-field
                    v-model="reason"
                    rows="5"
                    autosize
                    type="textarea"
                    maxlength="50"
                    placeholder="请填写纠纷原因"
                    show-word-limit
                    class="post-sale__post-sale-textarea"
                />
                <div class="post-sale__post-sale-title">上传相关凭证</div>
                <van-uploader
                    v-model="previewImgList"
                    :after-read="afterRead"
                />
            </div>
        </div>
        <!-- 纠纷说明 -->
        <div class="post-sale__warning-wrapper">
            <div class="post-sale__warning-title">
                <div class="post-sale__warning-title-divider"></div>
                <span>申请纠纷注意事项</span>
            </div>
            <div class="post-sale__warning-info">1：自动确认收货后，平台质保结束！请务必在质保期内使用！</div>
            <div class="post-sale__warning-info">2：质保期结束后，无法发起纠纷</div>
            <div class="post-sale__warning-info">3：平台将尽全力处理纠纷，但无法保证一定能追回损失</div>
            <div class="post-sale__warning-info">4：请勿随意发起纠纷，恶意纠纷者，平台将封号处理，并保留法律追究的权力！</div>
            <div class="post-sale__warning-info">5：囤货有较高的纠纷风险概率，且较难追回资金损失，请勿囤货！</div>
            <div class="post-sale__submit-button-wrapper">
                <van-button
                    class="post-sale__submit-button"
                    type="danger"
                    round
                    @click="postSale"
                >
                    我已阅读并确认申请纠纷
                </van-button>
            </div>
        </div>
        
    </div>
</template>

<script>
import {Field, Uploader, NavBar, Button, Sticky} from "vant";
import {navMixins, wechatMixins} from "@/mixins.js";
import request from "@/utils/request.js";

export default {
    name: "PostSale",
    mixins: [navMixins, wechatMixins],
    components: {
        [Field.name]: Field,
        [Uploader.name]: Uploader,
        [NavBar.name]: NavBar,
        [Button.name]: Button,
        [Sticky.name]: Sticky
    },
    data() {
        return {
            orderNo: undefined,
            skuName: undefined,
            skuCode: undefined,
            reason: "",
            previewImgList: [],
            evidenceList: []
        };
    },
    mounted() {
        this.orderNo = this.$route.query.orderNo;
        this.skuName = this.$route.query.skuName;
        this.skuCode = this.$route.query.skuCode;
    },
    methods: {
        async postSale() {
            const {response} = await request.post("/customer/order/postSale", {
                data: {
                    orderNo: this.orderNo,
                    reason: this.reason,
                    reasonType: "OTHER",
                    skuCode: this.skuCode,
                    evidenceList: this.evidenceList

                }
            });
            if (response.ok) {
                this.$notify({message: "发起售后成功", type: 'success'});
                this.$router.replace(`/order/${this.orderNo}`);
            }
        },
        async afterRead(file) {
            let formData = new FormData();
            formData.append('file', file.file);

            const {response, data} = await request.post('/resource/image/upload', {
                body:  formData,
            });
            if (response.ok) {
                this.evidenceList = [...this.evidenceList, data.url];
            }
        }
    }
}
</script>

<style lang="less">
@import "@/style/base.less";

.post-sale__goods-sku-name {
    background-color: white;
    padding: 8px;
    font-size: @font-size-title;
    color: @font-color-title;
    line-height: @line-height-title;
    font-weight: @font-weight-title;
}

.post-sale__post-sale-wrapper {
    background-color: white;
    padding: 8px;
    margin-top: 8px;
}

.post-sale__post-sale-title {
    padding: 8px 0;
}

.post-sale__post-sale-textarea {
    border: 1px dashed @color-border;
    border-radius: 4px;

    &.van-cell::after {
        border-bottom: none;
    }
}

.post-sale__warning-wrapper {
    background-color: white;
    padding: 8px;
    margin-top: 8px;
    padding-bottom: calc(constant(safe-area-inset-bottom) + 8px);
    padding-bottom: calc(env(safe-area-inset-bottom) + 8px);
}

.post-sale__warning-title-divider {
    display: inline-block;

    &::before {
        content: "";
        border-left: 4px solid @color-theme;
        height: 100%;
        margin-right: 8px;
    }
}

.post-sale__warning-title {
    padding: 8px 0;
    font-size: @font-size-title;
    color: @font-color-title;
    line-height: @line-height-title;
    font-weight: @font-weight-title;
}

.post-sale__warning-info {
    font-size: @font-size-normal;
    color: @font-color-title;
    line-height: @line-height-normal;
    font-weight: @font-weight-normal;
}

.post-sale__submit-button-wrapper {
    width: 100%;
    text-align: center;
    margin-top: 8px;
}

.post-sale__submit-button {
    width: 80%;
}
</style>